// import DropdownIndicatorForSelect from "components/DropdownIndicatorForSelect"
import customStyles from "components/Pickers/styles"
import React, { useState, useEffect } from "react"
import GooglePlacesAutocomplete, {
  geocodeByPlaceId,
  getLatLng,
} from "react-google-places-autocomplete"

const extractDetails = (
  address: google.maps.GeocoderAddressComponent[] = [],
  data: any = {}
) => {
  const city = address.find((item: google.maps.GeocoderAddressComponent) =>
    item.types.includes("locality")
  )
  const province = address.find((item: google.maps.GeocoderAddressComponent) =>
    item.types.includes("administrative_area_level_1")
  )

  const county = address.find((item: google.maps.GeocoderAddressComponent) =>
    item.types.includes("administrative_area_level_2")
  )
  const zipCode = address?.find((item: google.maps.GeocoderAddressComponent) =>
    item.types.includes("postal_code")
  )

  // Street is all text before city
  const streetArray: string[] = []
  data?.value?.terms.every((item: { value: string }) => {
    if (item.value === city?.long_name) return false
    streetArray.push(item.value)
    return true
  })

  return {
    city: city?.long_name || "",
    state: province?.long_name || "",
    county: county?.long_name || "",
    zipCode: zipCode?.long_name || "",
    street: streetArray.join(", "),
  }
}

const GoogleAutoComplete = (props: {
  defaultValue?: string
  label?: string
  onSelect: Function
  errorText?: string
}) => {
  const [value, setValue] = useState<any>(null)

  const loadData = async (data: any) => {
    if (!data) return
    const [place] = await geocodeByPlaceId(data?.value?.place_id)
    const latLng = await getLatLng(place)
    const { street, city, state, zipCode, county } = extractDetails(
      place?.address_components,
      data
    )
    const output = {
      label: data.label,
      street,
      county,
      city,
      state,
      zipCode,
      ...latLng,
    }

    props?.onSelect(output)
  }

  useEffect(() => {
    loadData(value)
  }, [value])

  return (
    <GooglePlacesAutocomplete
      apiKey={process.env.REACT_APP_API_KEY_GOOGLE_MAPS}
      selectProps={{
        value,
        onKeyDown: () => {
          //get text input here
        },
        styles: customStyles({
          border: props.errorText ? "1px solid red" : "",
        }),
        // components: props.errorText
        //   ? { DropdownIndicator: DropdownIndicatorForSelect }
        //   : {},
        onChange: setValue,
        defaultInputValue: props.defaultValue,
        placeholder: "Type to search address",
        onFocus: (event) => event.target.select(),
        noOptionsMessage: () => "Type to search address",
      }}
    />
  )
}

export default GoogleAutoComplete
